import { render, staticRenderFns } from "./ProgressiveDiscountNotice.vue?vue&type=template&id=5c119a71&scoped=true&"
import script from "./ProgressiveDiscountNotice.vue?vue&type=script&lang=js&"
export * from "./ProgressiveDiscountNotice.vue?vue&type=script&lang=js&"
import style0 from "./ProgressiveDiscountNotice.vue?vue&type=style&index=0&id=5c119a71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c119a71",
  null
  
)

export default component.exports